import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";
import PreviousOrderHelper from "../../common/helpers/PreviousOrderHelper";

export default function TransferResultDialog(props) {

  const [title, setTitle] = useState("");
  const [bodyHeadline, setBodyHeadline] = useState("");
  const [bodyContent, setBodyContent] = useState("");
  const [buttonCaption, setButtonCaption] = useState("");

  const { t } = useTranslation(NAMESPACE_REMOTE);

  useEffect(() => {
    if (props.transferActive) {
      setTitle(t("PROMPT.WSHOP2.TRANSFER_RESULT_DIALOG.TITLE_SUCCESS"));
      setBodyHeadline(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_IN_PROGRESS_1"));
      setBodyContent(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_IN_PROGRESS_2"));
      setButtonCaption("");

      if (props.request) {
        console.log(props.request);
      }
    }
    else if (props.error) {
      setTitle(t("PROMPT.WSHOP2.TRANSFER_RESULT_DIALOG.TITLE_ERROR"));
      setBodyHeadline(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_ERROR_1"));
      setBodyContent(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_ERROR_2") + " " + props.error);
      setButtonCaption(t("PROMPT.WSHOP2.TRANSFER_RESULT_DIALOG.BUTTON_CLOSE_ERROR"));

      console.error(props.error);
    }
    else if (props.response) {
      setTitle(t("PROMPT.WSHOP2.TRANSFER_RESULT_DIALOG.TITLE_SUCCESS"));
      setBodyHeadline(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_SUCCESS_1"));
      setBodyContent(t("TEXT.WSHOP2.TRANSFER_RESULT_DIALOG.HEADLINE_SUCCESS_2") +  " " + props.response.data.auftragId);
      setButtonCaption(t("PROMPT.WSHOP2.TRANSFER_RESULT_DIALOG.BUTTON_CLOSE_SUCCESS"));

      console.log(props.response);
    }
  }, [props.transferActive, props.request, props.error, props.response, t]);

  const navigate = useNavigate();
  const handleCloseClicked = () => {
    if (props.error) {
      props.onHide();
    }
    else if (props.response && props.response.data.auftragId) {
      // It was not possible to use this logic es a hook, because
      // the useEffect inside the hook to set the local storage was not called
      // if a useNavigate follows the setters. Seems to be a
      // general problem with hooks.
      PreviousOrderHelper.setCachedProductKey(props.treeItemKey);
      PreviousOrderHelper.setCachedOrder(props.request);

      navigate("/home", { replace: true });
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}>
      <Modal.Header>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{bodyHeadline}</h4>
        <p>{bodyContent}</p>
      </Modal.Body>
        {props.transferActive === false && (
          <Modal.Footer>
            <Button 
            variant="primary"
            className="text-white"
            onClick={handleCloseClicked}>
              {buttonCaption}
            </Button>
          </Modal.Footer>
        )}
    </Modal>
  );
}